import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={23.753}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 34732 37581"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541855840">
        <path
          d="M16831 843c-884 1389-149 1034-157 3045-765-412-1088-712-2011-1164-1659-813-584-61-1505-1261C11913-158 10706 103 8576 113 4140 133 762-958 0 3260c2361-109 3013-112 4683-99 8884 75 11815-1413 12011 5663-16 3893 256 20404-147 22789-451 315-935 776-1575 1144-2398 1378-2637-132-2623 4806l10079 18c0-4011 279-3388-2495-4730-2211-1069-1913-2118-1904-4946 16-4614-5-9234-5-13849-1-13605-1516-10374 16708-10742-915-4126-3268-3177-8617-3201-6152-26-1771 711-8099 3803 45-1923 1170-3141-1185-3073z"
          className="fil0"
        />
        <path
          d="M21807 3764c1315 2916 1522 2540 6155 2548 3357 6 4854 410 5847-2566l-12002 18zM909 3770c658 2246 1894 2517 4587 2517 4030 0 6591 602 7393-2543L909 3770z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
